module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.accountMission.startTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accountMission.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accountMission.description))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.accountMission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-554a726c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountMissionsRow.vue
// module id = 523
// module chunks = 0